module.exports = __webpack_public_path__ + "img/yahav.a8c09633.jpg";